import React from "react";
import { MenuItem } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const CompetitorFilterAdvanced = ({ providers = [], selectedProvider = "", onChange, onClose, providerLogos = {} }) => {
    const { t } = useTranslation();

    const handleSelect = (value) => {
        onChange({ target: { value } });
        if (onClose) onClose();
    };
    return (
        <>
            <MenuItem
                value=""
                selected={selectedProvider === ""}
                onClick={() => handleSelect("")}
            >
                <em>{t('enw-tab-all')}</em>
            </MenuItem>
            {providers.sort((a, b) => a?.localeCompare(b)).map((provider) => (
                <MenuItem
                    key={provider}
                    value={provider}
                    selected={selectedProvider === provider}
                    onClick={() => handleSelect(provider)}
                >
                    {providerLogos[provider] && (
                        <img
                            src={providerLogos[provider]}
                            alt={provider}
                            style={{ width: 65, height: 35, marginRight: 8, verticalAlign: "middle", borderRadius: 4 }}
                        />
                    )}
                    {/* {provider.charAt(0).toUpperCase() + provider.slice(1)} */}
                </MenuItem>
            ))}
        </>
    );
};

export default CompetitorFilterAdvanced;